/** Media-query hooks. Desktop (≥ 900 px, the same breakpoint as the CSS sidebar) gets tables, the week calendar and side panels. */
import { useSyncExternalStore } from "react";

export const DESKTOP_QUERY = "(min-width: 900px)";

export function useMediaQuery(query: string): boolean {
  const mql = () => (typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query) : null);
  return useSyncExternalStore(
    (fn) => {
      const m = mql();
      if (!m) return () => undefined;
      m.addEventListener?.("change", fn);
      return () => m.removeEventListener?.("change", fn);
    },
    () => mql()?.matches ?? false,
    () => false,
  );
}

export const useIsDesktop = () => useMediaQuery(DESKTOP_QUERY);
